import { render, staticRenderFns } from "./CommissionInfo.vue?vue&type=template&id=e6a4f77e&scoped=true"
import script from "./CommissionInfo.vue?vue&type=script&lang=js"
export * from "./CommissionInfo.vue?vue&type=script&lang=js"
import style0 from "./CommissionInfo.vue?vue&type=style&index=0&id=e6a4f77e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a4f77e",
  null
  
)

export default component.exports